import PropTypes from 'prop-types';
import Layout from 'components/Layout';
import Timeline from 'components/Timeline';
import { useState } from 'react';
import Styles from './About.module.scss';

export default function AboutPage({ route }) {
    const [sort, setSort] = useState('asc');

    const handleOnSort = () => {
        setSort(prev => (prev === 'asc' ? 'desc' : 'asc'));
    };

    return (
        <Layout route={route} section="about" seo={{ title: 'About' }}>
            <section className="section has-background-white py-6">
                <div className="container is-size-5">
                    <div className="columns">
                        <div className="column is-8 is-offset-2">
                            <h1 className="title is-unselectable has-text-centered has-text-primary mb-6">
                                About me
                            </h1>
                            <hr />
                            <p className="has-text-grey-dark mb-3">
                                My name is Bruno Domingos and I am a proactive and focused developer
                                with eight years’ experience in a variety of development positions
                                with a personal taste for frontend development.
                            </p>
                            <p className="has-text-grey-dark">
                                Organised, curious, passionate and a keen eye for detail. A person
                                who loves what he does.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container is-size-5 py-6">
                    <div className="columns">
                        <div className="column is-8 is-offset-2">
                            <h2 className="title is-unselectable is-4 has-text-centered has-text-primary mb-6">
                                Core skills
                            </h2>
                            <hr />

                            <div className="content">
                                <ul>
                                    <li>
                                        <p className="has-text-grey-dark mb-3">
                                            Skilled frontend developer
                                        </p>
                                    </li>
                                    <li>
                                        <p className="has-text-grey-dark mb-3">
                                            Passionate for UI&UX
                                        </p>
                                    </li>
                                    <li>
                                        <p className="has-text-grey-dark mb-3">
                                            Curious and aware with current and new development tools
                                            and practices
                                        </p>
                                    </li>
                                    <li>
                                        <p className="has-text-grey-dark">
                                            Experience in hybrid mobile applications
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container is-size-5 pb-6">
                    <div className="columns">
                        <div className="column is-8 is-offset-2">
                            <h2 className="title is-unselectable is-4 has-text-centered has-text-primary mb-6">
                                Education
                            </h2>
                            <hr />

                            <div className="content">
                                <p className="has-text-grey-dark">
                                    Bachelor degree in Design & Multimedia @{' '}
                                    <a
                                        href="https://www.uc.pt/fctuc"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="has-text-info"
                                    >
                                        FCTUC - Faculdade de Ciências e Tecnologia da Universidade
                                        de Coimbra
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container is-size-5">
                    <div className="columns">
                        <div className="column is-12">
                            <h2 className="title is-unselectable is-4 has-text-centered has-text-primary mb-6 is-flex is-justify-content-center is-align-items-center">
                                Professional experience{' '}
                                <span
                                    className={`icon ml-4 ${Styles.toggleSort}`}
                                    onClick={handleOnSort}
                                >
                                    <span
                                        className={`is-unselectable ${
                                            sort === 'desc' ? 'has-text-info' : 'has-text-primary'
                                        }`}
                                    >
                                        &darr;
                                    </span>
                                    <span
                                        className={`is-unselectable ${
                                            sort === 'asc' ? 'has-text-info' : 'has-text-primary'
                                        }`}
                                    >
                                        &uarr;
                                    </span>
                                </span>
                            </h2>
                            <hr />

                            <span className="timeline-path is-hidden-mobile"></span>

                            <Timeline sort={sort} />
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
}

AboutPage.propTypes = {
    route: PropTypes.string,
};
